// Logout.js — signs out and returns to the login screen.
import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const Logout = () => {
  const { logout, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      logout();
    } else {
      window.location.href = '/login';
    }
  }, [isAuthenticated, logout]);

  return <p className="status-line">Signing out...</p>;
};

export default Logout;
